import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Stretch the background underlay to the full viewport width while keeping the row content
   * centred. Useful for full-bleed banners inside a constrained Layout Builder canvas.
   *
   * @type {Boolean|String}
   * @default false
   */
  fullbleed: booleanAttribute(),
  /**
   * Theme colour token name (e.g. "primary", "secondary", "surface", "tertiary"). Sets the
   * background of the row underlay and forwards the matching on-color and on-color-link tokens to
   * the row contents so headings and anchors pick up the correct contrast.
   *
   * @type {String}
   * @default undefined
   */
  color: {
    type: String,
    default: undefined,
  },
  /**
   * CSS shorthand margin string applied to the row wrapper.
   *
   * @type {String}
   * @default undefined
   */
  margin: {
    type: String,
    default: undefined,
  },
  /**
   * CSS shorthand padding string (1–4 values). Parsed into per-side custom properties so the
   * small-breakpoint cap (--sp-comp-layout-row-padding-max-sm, 1.5rem) can apply independently per
   * edge.
   *
   * @type {String}
   * @default undefined
   */
  padding: {
    type: String,
    default: undefined,
  },
  /**
   * CSS position applied to the wrapper. "relative" (the default) lets the background underlay
   * paint behind the row content; "static" hides the underlay so the row sits transparent over its
   * parent.
   *
   * @type {String}
   * @storybook-control select
   * @default "relative"
   */
  position: {
    type: String,
    default: "relative",
    validator: (value) => ["relative", "static"].includes(value),
  },
});
